import { Modal } from "antd";
import React from "react";

// In-app replacement for window.alert(); keeps line breaks in the message
const showAlert = (content, title = 'Attention') => Modal.warning({
    title,
    content: <div style={{ whiteSpace: 'pre-line' }}>{content}</div>,
    okText: 'OK',
    closable: true,
    maskClosable: true,
})

export { showAlert };
